import { useInfiniteQuery } from '@maui/react-query'
import { useThreatProfilesApiClient } from './client'

export const useListThreatProfileEventsQuery = (profileId, options = {}) => {
  if (profileId !== undefined && typeof profileId !== 'string') {
    throw new Error(`expected profileId as string, got ${typeof profileId}`)
  }

  if (typeof profileId === 'string' && !profileId.length) {
    throw new Error('expected profileId, got empty string')
  }

  const api = useThreatProfilesApiClient('profiles')
  const { search = {}, ...restOptions } = options

  return useInfiniteQuery({
    ...restOptions,
    queryFn: ({ pageParam }) => api.listEvents({ profileId, pageToken: pageParam, ...search }),
    queryKey: ['profile', 'events', profileId, search],
    enabled: (options.enabled ?? true) && !!profileId,
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    staleTime: Infinity,
  })
}
